import Sortable from 'sortablejs'

export default {
  mounted() {
    if (!this.editable) return

    const vm = this
    const el = document.getElementById('people')

    if (el) {
      const sortable = Sortable.create(el, {
        handle: '.sortable-handle',
        onUpdate(event) {
          const companyUsers = this.toArray().map((id, index) => {
            return { id: parseInt(id), position: index }
          })

          vm.$http.patch('/companies/' + vm.company.slug + '/company_users', {
            company_users: companyUsers
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/company/mixins/users.js